module.exports = __webpack_public_path__ + "static/media/Xurkitree_gaussian2.dd49a312.png";